import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { useState, useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import { getErrorMessage } from '../Rssi/errorHandler.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import PollManager from '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import { setDisarmAsync, getArmStateAsync, getPollArmStateAsync } from './armDisarmAsync.js';

var useDisarm = function (setError, onValidate, onClose, timeout) {
    if (timeout === void 0) { timeout = 30000; }
    var _a = useState(false), isPolling = _a[0], setIsPolling = _a[1];
    var pollerKey = 'armDisarm';
    var doPoll = function (transId, giid, client) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, PollManager.poll(function () { return __awaiter(void 0, void 0, void 0, function () {
                    var armingProcess, event_1, res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getPollArmStateAsync(giid, transId, 'DISARMED', client)];
                            case 1:
                                armingProcess = _a.sent();
                                if (!((armingProcess === null || armingProcess === void 0 ? void 0 : armingProcess.result) === 'OK')) return [3 /*break*/, 3];
                                event_1 = new Event('refresh-armdisarm');
                                document.dispatchEvent(event_1);
                                return [4 /*yield*/, getArmStateAsync(giid, client)];
                            case 2:
                                res = _a.sent();
                                onClose();
                                onValidate();
                                return [2 /*return*/, res];
                            case 3:
                                if ((armingProcess === null || armingProcess === void 0 ? void 0 : armingProcess.result) === 'WRONG_CODE') {
                                    setError(t('MPLIB_CODE_INCORRECT_ERROR_MESSAGE'));
                                    return [2 /*return*/, true];
                                }
                                return [2 /*return*/, false];
                        }
                    });
                }); }, {
                    key: pollerKey,
                    timeout: timeout,
                })];
        });
    }); };
    var startDisarm = function (giid, pinCode, client) { return __awaiter(void 0, void 0, void 0, function () {
        var transId, e_1, description;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    setIsPolling(true);
                    return [4 /*yield*/, setDisarmAsync(giid, pinCode, client)];
                case 1:
                    transId = _a.sent();
                    if (!transId) return [3 /*break*/, 3];
                    return [4 /*yield*/, doPoll(transId, giid, client)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setIsPolling(false);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    setIsPolling(false);
                    description = getErrorMessage()(e_1).description;
                    setError(description);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () { return function () {
        PollManager.cancel(pollerKey);
    }; }, []);
    return { isPolling: isPolling, startDisarm: startDisarm };
};

export { useDisarm as default };
